import React from "react";
import Lottie from "lottie-react";
import ekgAnimation from "../../assets/animation/ekg.json";
import styles from "../../css/ai-mode/typing-indicator.module.css";

const TypingIndicator: React.FC = () => {
  return (
    <div className={styles.typingWrapper}>
      <Lottie animationData={ekgAnimation} loop={true} />
    </div>
  );
};

export default TypingIndicator;
